import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SERVICES, CONTACT } from '../mock';

const Services = () => {
  const smsHref = `sms:+1${CONTACT.phone}?&body=${CONTACT.smsBody}`;
  return (
    <section id="services" className="bg-app py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="text-xs tracking-[0.3em] text-sky-400 uppercase font-semibold">Services</span>
            <h2 className="mt-3 font-cond font-700 text-4xl md:text-5xl text-white">What We Repair</h2>
          </div>
          <a href={`tel:+1${CONTACT.phone}`} className="nav-link text-sm flex items-center gap-1">
            Don't see your device? Call us <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.id} className="card-dark rounded-xl p-6 flex flex-col">
                <div className="flex items-start justify-between">
                  <span className="inline-flex w-11 h-11 rounded-lg bg-white/5 border border-white/10 items-center justify-center">
                    <Icon className="w-5 h-5 text-gray-200" />
                  </span>
                  <span className="px-2.5 py-1 rounded-full border border-sky-500/40 text-sky-400 text-[10px] tracking-wider uppercase font-semibold">
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-cond font-600 text-xl text-white">{s.title}</h3>
                <p className="mt-1.5 text-sm text-gray-400 flex-1">{s.desc}</p>
                <div className="mt-5 pt-4 border-t border-white/10 flex items-center justify-between">
                  <span className="font-cond font-600 text-lg text-white">{s.price}</span>
                  <a href={smsHref} className="text-sm text-gray-300 hover:text-sky-400 transition-colors flex items-center gap-1">
                    Book <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
